const initialState = {
    logErroChaveNfe: [],
    idFazenda: 0,
    fazenda: '',
    usuario: '',
    erro: '',
    dataCadastro: ''
};

export function logErroChaveNfe(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_LOG_ERRO_CHAVE_NFE':
            return {
                ...state,
                logErroChaveNfe: action.logErroChaveNfe
            };
        case 'LOG_ERRO_CHAVE_NFE_DETAIL':
            return {
                ...state,
                idFazenda: action.idFazenda,
                fazenda: action.fazenda,
                usuario: action.usuario,
                erro: action.erro,
                dataCadastro: action.dataCadastro
            };
        case "LOG_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE_LOG_ERRO_CHAVE_NFE":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}
